import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { IServicioContratado } from 'modelos/src';
import { firstValueFrom } from 'rxjs';
import { HelperService } from '../../../../../auxiliares/servicios/helper.service';
import { DialogService } from '../../../../../auxiliares/dialog/dialog.service';
import { ServiciosContratadosService } from '../servicios-contratados.service';
import { Lista2Service } from '../../../../../auxiliares/servicios/lista2.service';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-crear-editar-servicios',
  templateUrl: './crear-editar-servicios.component.html',
  styleUrl: './crear-editar-servicios.component.scss',
  standalone: false,
})
export class CrearEditarServiciosComponent implements OnInit {
  dialogRef = inject<MatDialogRef<CrearEditarServiciosComponent>>(
    MatDialogRef,
    { optional: true },
  );
  private route = inject(ActivatedRoute);
  private lista2 = inject(Lista2Service);
  helper = inject(HelperService);
  private dialogService = inject(DialogService);
  private service = inject(ServiciosContratadosService);

  public loading = false;
  public title?: string;
  public subtitle?: string;
  public form?: FormGroup;

  public id?: string | null;
  public servicio?: IServicioContratado;

  public urlIcono?: string;

  private createForm() {
    // nombre?: string;
    // icono?: string;
    // costo?: string;
    this.form = new FormGroup({
      nombre: new FormControl(this.servicio?.nombre, [Validators.required]),
      icono: new FormControl(this.servicio?.icono),
      costo: new FormControl(this.servicio?.costo, [Validators.required]),
      global: new FormControl(
        this.servicio?.global || false,
        Validators.required,
      ),
    });
  }

  private async listar() {
    this.servicio = await firstValueFrom(
      this.lista2.serviciosContratado(this.id!),
    );
  }

  public onUrlChange(url: string) {
    this.form.setValue({ ...this.form.value, icono: url });
  }

  public async onSubmit() {
    const res = await this.dialogService.confirm(
      `${this.id ? 'Editar' : 'Crear'} Servicio`,
      `¿Querés ${this.id ? 'editar' : 'crear'} servicio?`,
    );
    if (!res) return;
    try {
      const data = this.form?.value;
      if (this.id) {
        // Update
        await this.service.update(this.id, data);
        this.helper.notifSuccess('Servicio actualizado');
      } else {
        // Create
        await this.service.create(data);
        this.helper.notifSuccess('Servicio creado');
      }
      HelperService.volver();
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
  }

  private setTitles() {
    if (this.servicio) {
      this.title = 'Editar servicio ofrecido';
      this.subtitle = this.servicio?.nombre;
    } else {
      this.title = 'Crear servicio ofrecido';
    }
  }

  /////// HOOKS

  async ngOnInit() {
    const params = await firstValueFrom(this.route.paramMap);
    this.id = params.get('id');
    if (this.id) {
      await this.listar();
      this.urlIcono = this.servicio?.icono;
    }
    this.setTitles();
    this.createForm();
  }
}
